import { Button, Stack, Typography } from '@mui/material'
import { useLoginInfo } from 'app/_hooks'
import { default as NextLink } from 'next/link'
import { FC, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useBeforeLoginSessionStorage } from '~/hooks/useBeforeLoginSessionStorage'
import { Colors } from '~/libs/mui/theme'
import { VideoUnavailableReason } from '../hooks/useVideoDetail'

const VideoUnavailable: FC<{ unavailableReason?: VideoUnavailableReason }> = ({
  unavailableReason,
}) => {
  const { t } = useTranslation()
  const loginInfo = useLoginInfo()
  const { setBeforeLoginPage } = useBeforeLoginSessionStorage()

  const data: { title?: string; buttonTitle?: string; href?: string; showLogout?: boolean } =
    useMemo(() => {
      switch (loginInfo.status) {
        case 'notSignedIn':
          return {
            title: t('login_to_watch_the_full_video'),
          }
        case 'noProfile':
          return {
            title: t('create_a_profile_to_watch_the_full_video'),
            buttonTitle: t('create_profile'),
            href: '/profile/new',
          }
        case 'conflict':
          return { title: t('incorrect_login_method'), showLogout: true }
        case 'signedIn':
          switch (unavailableReason) {
            case 'REQUIRE_AUTH':
              return { title: t('not_logged_in') }
            case 'ALREADY_WITHDRAWAL':
              return {
                title: t('already_canceled'),
                buttonTitle: t('REACTIVATE'),
                href: '/profile/reactivate',
              }
            case 'REQUIRE_RESUBSCRIPTION':
              return {
                title: t('already_canceled'),
                buttonTitle: t('REACTIVATE'),
                href: '/profile/reactivate',
              }
            case 'REQUIRE_SUBSCRIPTION':
              return {
                title: t('please_choose_the_monthly_plan_to_watch_the_full_video'),
                buttonTitle: t('SUBSCRIBE'),
                href: '/profile/payment/new',
              }
            case 'INVALID_CHARGE':
              return {
                title: t('your_payment_information_is_invalid'),
                buttonTitle: t('UPDATE'),
                href: '/profile/payment/edit',
              }
          }
        default:
          return {}
      }
    }, [loginInfo, t, unavailableReason])

  return (
    <Stack
      textAlign='center'
      alignItems='center'
      bgcolor={Colors.color0D0D0E}
      paddingY={2}
      border={1}
      borderColor={Colors.color8c8c8c}
      borderRadius={2}
      padding={2}
    >
      <Typography fontWeight={700} fontSize={14}>
        {data.title}
      </Typography>
      <Button
        sx={{
          marginTop: 2,
          width: 1,
          borderRadius: { xs: 0, sm: 18 },
          maxWidth: { xs: 300, sm: 200 },
        }}
        variant='outlined'
        LinkComponent={NextLink}
        href={data.href ?? '/login'}
        onClick={() => setBeforeLoginPage()}
      >
        {data.buttonTitle ?? 'LOGIN'}
      </Button>
      {data.showLogout == true && (
        <Button variant='text' LinkComponent={NextLink} href='/logout'>
          <Trans i18nKey='logout' />
        </Button>
      )}
    </Stack>
  )
}

export default VideoUnavailable
